module.exports = __webpack_public_path__ + "img/7.15b13d4b.png";